import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDescription = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.138 2.8335C10.1715 2.8335 9.38802 3.617 9.38802 4.5835V5.75016C9.38802 6.71666 10.1715 7.50016 11.138 7.50016H16.9714C17.9379 7.50016 18.7214 6.71666 18.7214 5.75016V4.5835C18.7214 3.617 17.9379 2.8335 16.9714 2.8335H11.138Z",
		fill: "#808080"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.63802 5.20955C6.17046 5.29189 5.244 5.52574 4.57981 6.18993C3.55469 7.21505 3.55469 8.86497 3.55469 12.1648V19.1648C3.55469 22.4646 3.55469 24.1145 4.57981 25.1397C5.60494 26.1648 7.25486 26.1648 10.5547 26.1648H17.5547C20.8545 26.1648 22.5044 26.1648 23.5296 25.1397C24.5547 24.1145 24.5547 22.4646 24.5547 19.1648V12.1648C24.5547 8.86497 24.5547 7.21505 23.5296 6.18993C22.8654 5.52574 21.9389 5.29189 20.4714 5.20955V5.75016C20.4714 7.68316 18.9044 9.25016 16.9714 9.25016H11.138C9.20502 9.25016 7.63802 7.68316 7.63802 5.75016V5.20955ZM8.22135 16.5418C7.7381 16.5418 7.34635 16.9336 7.34635 17.4168C7.34635 17.9001 7.7381 18.2918 8.22135 18.2918H17.5547C18.0379 18.2918 18.4297 17.9001 18.4297 17.4168C18.4297 16.9336 18.0379 16.5418 17.5547 16.5418H8.22135ZM8.22135 20.6252C7.7381 20.6252 7.34635 21.0169 7.34635 21.5002C7.34635 21.9834 7.7381 22.3752 8.22135 22.3752H14.638C15.1213 22.3752 15.513 21.9834 15.513 21.5002C15.513 21.0169 15.1213 20.6252 14.638 20.6252H8.22135Z",
		fill: "#808080"
	})]
});
const ForwardRef = forwardRef(SvgDescription);
export default ForwardRef;
